module.exports = __webpack_public_path__ + "img/德尔福.png";